import { Action, Dispatch } from 'redux'
import { FirebaseDocRefType, FirebaseTimestamp } from 'firebase/index'
import { StoreTimesale, StoreTimesaleBread } from 'types/storeTimesale'
import { fetchStoreTimesaleAction } from 'reducks/storeTimesale/actions'
import { BreadsByType } from 'types/bread'
import { StockUnionType } from 'types/stock'
import { push } from 'connected-react-router'
import { State } from 'index'

const saveStoreTimesaleBreads = (storeRef: FirebaseDocRefType, selectedBreadsByType: BreadsByType) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const now = FirebaseTimestamp.now()
    const storeTimesale: StoreTimesale = getState().storeTimesale.storeTimesale
    if (storeTimesale) {
      const { ref, ...rest } = storeTimesale
      if (!ref) return
      // TODO 商品ごとに割引率を個別設定できるようになったらロジックを変更する
      const currentDiscountRate = storeTimesale.breads.reduce((prev, bread) => {
        return Math.max(prev, bread.discount_rate ?? 0)
      }, 0)
      // selectedBreadsByType を StoreTimesaleBread[] に変換
      const nextBreads: StoreTimesaleBread[] = Object.entries(selectedBreadsByType).reduce(
        (prev: StoreTimesaleBread[], [type, breads]) => {
          if (breads.length === 0) return prev
          breads.forEach((bread) => {
            const index = prev.findIndex((_bread) => _bread.bread_id === bread.bread_ref?.id)
            if (index !== -1) {
              prev[index].types.push(type as StockUnionType)
            } else {
              prev.push({
                bread_id: bread.bread_ref?.id || '',
                discount_rate: currentDiscountRate,
                types: [type as StockUnionType],
              })
            }
          })
          return prev
        },
        []
      )
      const nextStoreTimesale: StoreTimesale = {
        ...rest,
        breads: nextBreads,
        updated_at: now,
      }
      return ref
        .set(nextStoreTimesale, { merge: true })
        .then(() => {
          nextStoreTimesale.ref = ref
          dispatch(fetchStoreTimesaleAction(nextStoreTimesale))
          dispatch(push('/time_sale'))
        })
        .catch((error: unknown) => {
          console.error(error)
        })
    } else {
      const ref = storeRef.collection('store_timesales').doc()
      const discount_rate = 20
      const nextBreads: StoreTimesaleBread[] = Object.entries(selectedBreadsByType).reduce(
        (prev: StoreTimesaleBread[], [type, breads]) => {
          // breads が空の場合は prev をそのまま返す
          if (breads.length === 0) return prev
          // prev.bread_id が breads に含まれていれば prev.types に type を追加する
          breads.forEach((bread) => {
            const index = prev.findIndex((_bread) => _bread.bread_id === bread.bread_ref?.id)
            if (index !== -1) {
              prev[index].types.push(type as StockUnionType)
            } else {
              prev.push({
                bread_id: bread.bread_ref?.id || '',
                discount_rate,
                types: [type as StockUnionType],
              })
            }
          })
          return prev
        },
        []
      )
      const nextStoreTimesale: StoreTimesale = {
        breads: nextBreads,
        is_active: false,
        has_sent_notification: false,
        end_at: now,
        discount_rate,
        created_at: now,
        updated_at: now,
      }

      return ref
        .set(nextStoreTimesale, { merge: true })
        .then(() => {
          nextStoreTimesale.ref = ref
          dispatch(fetchStoreTimesaleAction(nextStoreTimesale))
          dispatch(push('/time_sale'))
        })
        .catch((error: unknown) => {
          console.error(error)
        })
    }
  }
}

export default saveStoreTimesaleBreads
